import { useParams } from 'react-router-dom';
import { usePagesRedirect } from '@shared/hooks/use-pages-redirect.ts';

export const useOpenEditor = (programId: number) => {
  const { code } = useParams<{ id: string; code: string }>();
  const { doRedirectWithSavePageUrl } = usePagesRedirect('programEditor');

  const edit = () => {
    // Изменить программу
    doRedirectWithSavePageUrl(`/programs/${code}/program-edit/${programId}`);
  };

  return {
    edit,
  };
};
